import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/MINE`;

export const LISTING_ENDPOINT = `${SHIPPING_EDGE}/api/shipments/getmyshipments`;

export const ROUTES = {
  ROOT: '/my-shipments',
};
